import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from './Wrapper';
import Logo from './Logo';
import InfoWrapper from './InfoWrapper';

import footerLogo from './footer_logo.png';

function GlobalFooter({ isBranded }) {
  return (
    <Wrapper>
      {isBranded && <Logo alt="Decisiv Logo" src={footerLogo} />}
      <InfoWrapper />
    </Wrapper>
  );
}

GlobalFooter.propTypes = {
  isBranded: PropTypes.bool,
};

GlobalFooter.defaultProps = {
  isBranded: false,
};

export default GlobalFooter;



// WEBPACK FOOTER //
// ./components/GlobalFooter/index.js